import { createBrowserRouter, Navigate } from "react-router-dom";
import { PAGES } from "@/constants";
import QuizPageContainer from "@/pages/quiz";
import ErrorPage from "@/pages/ErrorPage";
import VoucherPageNew from "@/pages/voucher";
import RootLayout from "@/pages/RootLayout";
import FeedbackPageView from "@/pages/feedbackForm";
import WaiverPage from "@/pages/waiver";
import ConsentPage from "@/pages/consent";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />, // layout with shared logic
    children: [
      {
        path: PAGES.home,
        element: <ErrorPage />,
      },
      {
        path: PAGES.voucher,
        element: <VoucherPageNew />,
      },
      {
        path: PAGES.quizInit,
        element: (
          <Navigate to={`${PAGES.quiz.replace(":quizId", "12000")}`} replace />
        ),
      },
      {
        path: PAGES.quiz,
        element: <QuizPageContainer />,
      },
      {
        path: PAGES.checkIn,
        element: <VoucherPageNew isCheckIn />,
      },
      {
        path: PAGES.unavailableStateForm,
        element: <FeedbackPageView />,
      },
      {
        path: PAGES.waiver,
        element: <WaiverPage />,
      },
      {
        path: PAGES.consent,
        element: <ConsentPage />,
      },
    ],
  },
]);
